import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
} from "@mui/material";
import axios from "axios";
import { useEffect, useState } from "react";
import { getAboutYouUserList } from "../../http/dashboard";

const questionsArr = [
  { title: "Sr No.", key: "idx" },
  {
    title: "Are you currently employed?",
    key: "isEmployed",
  },
  {
    title: "What kind of work do you do?",
    key: "workType",
  },
  {
    title: "Is this job full time or part time?",
    key: "employmentType",
  },
  {
    title: "What is your frequency of receiving this amount?",
    key: "incomeType",
    minWidth: "250px",
  },
  {
    title: "How much money goes into your bank account each time you get paid?",
    key: "incomeAmount",
    minWidth: "250px",
  },
  {
    title:
      "Do you have any additional income you want to add? Remember: Every dollar counts!",
    key: "additionalIncome",
    type: "array",
    minWidth: "400px",
  },
  {
    title: "Do you have Savings?",
    key: "savings",
    type: "array",
    minWidth: "300px",
  },
];
export default function IncomeTable(props) {
  const { listData, handleChangePage, page, totalCount } = props;
  return (
    <>
      <TableContainer
        component={Paper}
        sx={{ maxHeight: "calc(100vh - 210px)", overflow: "auto" }}
      >
        <Table sx={{ minWidth: 650 }} aria-label="sticky table" stickyHeader>
          <TableHead>
            <TableRow>
              {questionsArr?.map((ques) => {
                return (
                  <TableCell
                    style={{
                      verticalAlign: "top",
                      minWidth: ques.minWidth || "200px",
                      color: "#000",
                      fontSize: "15px",
                      verticalAlign: "top",
                    }}
                  >
                    {ques?.title}
                  </TableCell>
                );
              })}
            </TableRow>
          </TableHead>
          <TableBody>
            {listData?.map((user, idx) => {
              return (
                <TableRow>
                  {questionsArr?.map((item) => {
                    if (item.type != "array") {
                      return (
                        <TableCell
                          style={{
                            verticalAlign: "top",
                            minWidth: item.minWidth || "200px",
                            color: "#768896",
                            fontWeight: 500,
                            fontSize: "14px",
                          }}
                        >
                          {item?.key === "idx" ? idx + 1 : user?.[item?.key]}
                        </TableCell>
                      );
                    }
                    return (
                      <TableCell
                        style={{
                          verticalAlign: "top",
                          minWidth: item.minWidth || "200px",
                          color: "#768896",
                          fontWeight: 500,
                          fontSize: "14px",
                        }}
                      >
                        {user?.[item?.key]?.map((innerItem, idx) => {
                          return (
                            <span>
                              {innerItem?.type}{" "}
                              {innerItem?.amount
                                ? `: ${innerItem?.amount}`
                                : ""}{" "}
                              {idx + 1 != user?.[item?.key]?.length ? (
                                <br />
                              ) : (
                                ""
                              )}
                            </span>
                          );
                        })}
                      </TableCell>
                    );
                  })}{" "}
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        sx={{
          width: "100%",
          "& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows":
            {
              fontSize: "14px",
            },
          "& .MuiTablePagination-selectLabel, & .MuiTablePagination-select, & .MuiTablePagination-actions .MuiIconButton-root":
            {
              color: "black",
            },
        }}
        component={"div"}
        colSpan={3}
        count={totalCount}
        rowsPerPage={10}
        page={page}
        slotProps={{
          select: {
            inputProps: {
              "aria-label": "rows per page",
            },
            native: true,
          },
        }}
        rowsPerPageOptions={[]}
        onPageChange={handleChangePage}
      />
    </>
  );
}
